import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useGroupsContext } from '../../GroupsContext'

export const CreateEditBody: React.FC = () => {
  const { connectionOptions, fetching } = useGroupsContext()

  return (
    <>
      <NameFormItem help={HelpMessage.Name} />
      <DescriptionFormItem entityName="Group" />
      <CIMSFormItem
        label="Connections & Workflows"
        name="payItemConnections"
        help={HelpMessage.PayItems.Manage.Groups.Connections}
        description="Connections and Workflows can only have one Group. Selected connections and workflows will be moved to this Group if they are associated with another."
      >
        <CIMSSelect
          options={connectionOptions}
          loading={fetching}
          mode="multiple"
        />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditBody
